import { render } from "./RefundDetailsModal.vue?vue&type=template&id=512b2bb6&scoped=true"
import script from "./RefundDetailsModal.vue?vue&type=script&lang=js"
export * from "./RefundDetailsModal.vue?vue&type=script&lang=js"

import "./RefundDetailsModal.vue?vue&type=style&index=0&id=512b2bb6&scoped=true&lang=css"

import exportComponent from "/app/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-512b2bb6"]])

export default __exports__